var l = Object.defineProperty;
var m = (i) => {
  throw TypeError(i);
};
var p = (i, e, t) => e in i ? l(i, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : i[e] = t;
var d = (i, e, t) => p(i, typeof e != "symbol" ? e + "" : e, t), S = (i, e, t) => e.has(i) || m("Cannot " + t);
var h = (i, e, t) => e.has(i) ? m("Cannot add the same private member more than once") : e instanceof WeakSet ? e.add(i) : e.set(i, t);
var n = (i, e, t) => (S(i, e, "access private method"), t);
import { A as y, d as v, m as f, N as T, o as b, n as c, q as $, a as M } from "./vidstack-D3W_YeLC.js";
var r, u;
class g {
  constructor(e, t) {
    h(this, r);
    d(this, "scope", v());
    d(this, "currentSrc", null);
    d(this, "audioGain");
    this.media = e, this.ctx = t, this.audioGain = new y(e, (a) => {
      this.ctx.notify("audio-gain-change", a);
    });
  }
  setup() {
    new f(this, this.ctx), "audioTracks" in this.media && new T(this, this.ctx), b(() => {
      this.audioGain.destroy(), this.media.srcObject = null, this.media.removeAttribute("src");
      for (const e of this.media.querySelectorAll("source")) e.remove();
      this.media.load();
    });
  }
  get type() {
    return "";
  }
  setPlaybackRate(e) {
    this.media.playbackRate = e;
  }
  async play() {
    return this.media.play();
  }
  async pause() {
    return this.media.pause();
  }
  setMuted(e) {
    this.media.muted = e;
  }
  setVolume(e) {
    this.media.volume = e;
  }
  setCurrentTime(e) {
    this.media.currentTime = e;
  }
  setPlaysInline(e) {
    c(this.media, "playsinline", e);
  }
  async loadSource({ src: e, type: t }, a) {
    this.media.preload = a || "", $(e) ? (this.removeSource(), this.media.srcObject = e) : (this.media.srcObject = null, M(e) ? t !== "?" ? this.appendSource({ src: e, type: t }) : (this.removeSource(), this.media.src = n(this, r, u).call(this, e)) : (this.removeSource(), this.media.src = window.URL.createObjectURL(e))), this.media.load(), this.currentSrc = { src: e, type: t };
  }
  /**
   * Append source so it works when requesting AirPlay since hls.js will remove it.
   */
  appendSource(e, t) {
    const a = this.media.querySelector("source[data-vds]"), s = a ?? document.createElement("source");
    c(s, "src", n(this, r, u).call(this, e.src)), c(s, "type", e.type !== "?" ? e.type : t), c(s, "data-vds", ""), a || this.media.append(s);
  }
  removeSource() {
    var e;
    (e = this.media.querySelector("source[data-vds]")) == null || e.remove();
  }
}
r = new WeakSet(), u = function(e) {
  const { clipStartTime: t, clipEndTime: a } = this.ctx.$state, s = t(), o = a();
  return s > 0 && o > 0 ? `${e}#t=${s},${o}` : s > 0 ? `${e}#t=${s}` : o > 0 ? `${e}#t=0,${o}` : e;
};
export {
  g as H
};
